var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_page"},[_c('iframe',{staticClass:"main_page_frame",attrs:{"src":"https://shop.ausbau-akademie.de/veranstaltungen/"}})])}]

export { render, staticRenderFns }